import {Selector} from 'reselect';
import {SisName} from 'util/SisName';
import {BSOwner} from 'module/BSCollection/type/BSCollectionStateType';
import {SisNameBS} from 'module/BSCollection/type/SisNameBS';


const unsetFunc = () => {
	console.error('unset BSCollectionUrlParamSelectorDict')
	return []
}

export type UrlParamSelectorType = Selector<any, BSOwner[]>
export type UrlParamSelectorDictType = Record<SisNameBS, UrlParamSelectorType>

export const BSCollectionUrlParamSelectorDict: UrlParamSelectorDictType = {
	[SisName.Booking]: unsetFunc,
	[SisName.Persurl]: unsetFunc,
	[SisName.V2]: unsetFunc,
	[SisName.V2Data]: unsetFunc,
	[SisName.Ist]: unsetFunc,
	[SisName.StTagZu]: unsetFunc,
	[SisName.TaskZu]: unsetFunc,
	[SisName.Holiday]: () => [''],
	[SisName.StatusForecast]: unsetFunc,
	[SisName.PlanEvent]: unsetFunc,
	[SisName.KoKeyConf]: unsetFunc,
}

export function setUrlParamSelectorDict(dict: Partial<UrlParamSelectorDictType>) {
	Object.assign(BSCollectionUrlParamSelectorDict, dict)
}